export const CUSTOMER_USER_GROUPS = {
    ADD_CUSTOMER_GROUP_BTN: "add-customer-group",
    GROUP_NAME_INPUT: "group_name_input",
    SAVE_BTN: "save-btn",
    CUSTOMER_GROUP: "customer-group",
    WHITELIST_TOGGLE: "whitelist-toggle",
    EXCLUDE_NEW_GROUPS_TOGGLE: "exclude-new-groups-toggle",
    EXCLUDE_GROUP_TOGGLE: "exclude-group-toggle",
    ADD_RULE_BTN: "add-rule",
    REMOVE_GROUP_BTN: "remove-group-btn",
    GROUP_RULE: "group-rule",
    RULE_TEXT_INPUT: "rule_text",
    RULE_FIELD_SELECT: "rule-field-select",
    RULE_FIELD: "rule-field",
    ENTER_RULE_VALUE_ICON: "enter-rule-value",
    REMOVE_RULE_BTN: "remove-rule-btn",
    CONFIRM_REMOVE_GROUP_BTN: "confirm-remove-group-btn",
    CANCEL_REMOVE_GROUP_BTN: "cancel-remove-group-btn",
    CONFIRM_REMOVE_RULE_BTN: "confirm-remove-rule-btn",
    CANCEL_REMOVE_RULE_BTN: "cancel-remove-rule-btn",
    RULE_CHIP: "rule-chip",
    HEADER_TOOLBAR: "header-toolbar",
    ERROR_MESSAGE_DIALOG: "error-message-dialog",
    DIALOG_CONFIRM: "dialog-confirm",
    DIALOG_CANCEL: "dialog-cancel",
    FILTER_MENU: "filter-menu",
};
